'use client'

import { useMemo, useState } from "react"
import { usePathname } from "next/navigation"
import { MapPinHouse, Search } from 'lucide-react'
import { navigateUrl } from "@/utils/client-request"
import BranchCard from "./BranchCard"
import EmptyState from "../elements/EmptyState"

export default function BranchList({ branches, vendor }: { branches: any, vendor?: any }) {
  const pathname = usePathname()
  const [query, setQuery] = useState('')

  const filtered = useMemo(() => {
    const list = (branches || []).filter((b: any) => b?.isActive !== false)
    if (!query.trim()) return list
    const q = query.trim().toLowerCase()
    return list.filter((b: any) => [b.name, b.address, b.phone].filter(Boolean).some((v: string) => v.toLowerCase().includes(q)))
  }, [branches, query])

  return (
    <div className="w-full px-4 lg:px-6 pt-8 lg:pt-12 pb-20">
      <nav aria-label="Breadcrumb" className="flex items-center gap-x-1.5 text-xs text-muted-foreground">
        <a href={navigateUrl('/', pathname)} className="transition-colors duration-150 hover:text-foreground focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground">Нүүр</a>
        <span aria-hidden>/</span>
      </nav>

      <div className="mt-2 mb-10 lg:mb-12 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <div>
          <h1 className="text-3xl sm:text-4xl tracking-tight text-foreground">Салбарууд</h1>
          {filtered.length > 0 && <p className="mt-3 text-sm text-muted-foreground tabular-nums">{filtered.length} байршилд үйлчилж байна</p>}
        </div>
        {(branches?.length || 0) > 3 && (
          <label className="flex items-center gap-2 h-10 w-full sm:w-72 border-b border-border focus-within:border-foreground transition-colors duration-150">
            <Search aria-hidden className="size-4 text-muted-foreground shrink-0" strokeWidth={1.5} />
            <span className="sr-only">Салбар хайх</span>
            <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Салбар хайх" className="flex-1 min-w-0 h-full bg-transparent border-0 p-0 text-sm outline-none focus:outline-none focus:ring-0 placeholder:text-muted-foreground" />
          </label>
        )}
      </div>

      {filtered.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-1 gap-y-12 lg:gap-y-16">
          {filtered.map((branch: any, index: number) => <BranchCard key={branch.id} branch={branch} vendor={vendor} index={index} />)}
        </div>
      ) : (
        <EmptyState
          icon={MapPinHouse}
          title={query ? 'Илэрц олдсонгүй' : 'Салбарын мэдээлэл хоосон байна'}
          description={query ? `"${query}" гэсэн нэртэй салбар олдсонгүй. Өөр түлхүүр үг ашиглан дахин хайна уу.` : 'Яг одоогоор салбарын мэдээлэл байхгүй байна. Хэсэг хугацааны дараа дахин шалгана уу.'}
        />
      )}
    </div>
  )
}
